/**
 * VAT Toggle — Production-Ready Build
 * Fixes: MutationObserver infinite loop, querySelectorAll on every mutation,
 *        JSON re-parsing, option1-only variant match, localStorage no try/catch,
 *        setTimeout race condition.
 * Functionality: identical to original — inc/exc toggle, Empire AJAX cart support,
 *                variant price sync, localStorage persistence.
 */

// ---------------------------------------------------------------------------
// 1. CORE VAT TOGGLE
// ---------------------------------------------------------------------------

window.VatToggle = (function () {

  // ✅ Safe localStorage read — won't crash in private/quota-exceeded contexts
  function readStorage(key, fallback) {
    try {
      return localStorage.getItem(key) || fallback;
    } catch (e) {
      return fallback;
    }
  }

  function writeStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      // silently ignore — toggle still works for the session
    }
  }

  // ✅ VAT rate as a named constant — easy to update if rate changes
  var VAT_MULTIPLIER = 1.2;

  function formatPrice(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function apply(mode) {
    document.querySelectorAll('[data-price-inc]').forEach(function (el) {
      var incPence = parseInt(el.dataset.priceInc, 10);

      if (!incPence) return;

      var displayPence =
        mode === 'exc'
          ? Math.round(incPence / VAT_MULTIPLIER)
          : incPence;

var priceText = formatPrice(displayPence);
var vatLabel = mode === 'inc' ? 'Inc VAT' : 'Ex VAT';

var nestedMoney = el.querySelector('.money');

if (nestedMoney) {
  nestedMoney.innerHTML =
    priceText + ' <span class="vat-labels">' + vatLabel + '</span>';
} else {
  el.innerHTML =
    priceText + ' <span class="vat-labels">' + vatLabel + '</span>';
}




      

      // Empire AJAX cart subtotal safety marker (same as original)
      if (
        el.hasAttribute('data-atc-banner-cart-subtotal') ||
        el.closest('[data-atc-banner-cart-subtotal]')
      ) {
        el.dataset.vatProcessed = mode;
      }
    });
  }

  return {
    // ✅ mode read lazily on first access so DOM is ready
    get mode() {
      if (!this._mode) {
        this._mode = readStorage('vat_display_mode', 'inc');
      }
      return this._mode;
    },

    set mode(val) {
      this._mode = val;
    },

    formatPrice: formatPrice,

    apply: function () {
      apply(this.mode);
    },

    setMode: function (mode) {
      this.mode = mode;
      writeStorage('vat_display_mode', mode);
      apply(mode);
    }
  };

})();




// ---------------------------------------------------------------------------
// 3. TOGGLE BUTTON UI
// ---------------------------------------------------------------------------

// ---------------------------------------------------------------------------
// 3. VAT RADIO UI
// ---------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {

  var checkbox = document.getElementById('vat-checkbox');

  if (!checkbox) return;

  var incLabel = document.querySelector('[data-label="inc"]');
  var excLabel = document.querySelector('[data-label="exc"]');

  function updateUI(mode) {

    checkbox.checked = mode === 'exc';

    incLabel.classList.toggle('active', mode === 'inc');
    excLabel.classList.toggle('active', mode === 'exc');

  }

  updateUI(window.VatToggle.mode);

  checkbox.addEventListener('change', function () {

    var mode = this.checked ? 'exc' : 'inc';

    window.VatToggle.setMode(mode);

    updateUI(mode);

  });

  window.VatToggle.apply();

});
// ---------------------------------------------------------------------------
// 4. EMPIRE AJAX CART / DRAWER OBSERVER
//    ✅ Fixed: re-entrancy guard stops the infinite loop
//    ✅ Fixed: only fires when a [data-price-inc] node is actually added
//    ✅ Fixed: scoped to cart/drawer container — not entire body
// ---------------------------------------------------------------------------

(function () {

  var vatApplyPending = false;

  function onCartMutation(mutations) {
    // ✅ If we triggered this mutation ourselves, ignore it
    if (vatApplyPending) return;

    // ✅ Only react when a node containing [data-price-inc] is injected
    var hasPriceNode = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return (
          n.nodeType === 1 &&
          (
            (typeof n.matches === 'function' && n.matches('[data-price-inc]')) ||
            (typeof n.querySelector === 'function' && n.querySelector('[data-price-inc]'))
          )
        );
      });
    });

    if (!hasPriceNode) return;

    vatApplyPending = true;

    // ✅ requestAnimationFrame — batches into next paint, not a tight sync loop
    requestAnimationFrame(function () {
      if (window.VatToggle && typeof window.VatToggle.apply === 'function') {
        window.VatToggle.apply();
      }

      vatApplyPending = false;
    });
  }

  var vatObserver = new MutationObserver(onCartMutation);

  document.addEventListener('DOMContentLoaded', function () {
    // ✅ Scope to cart/drawer — try common Empire selectors before falling
    //    back to document.body only as a last resort
    var cartRoot =
      document.querySelector('#ajax-cart') ||
      document.querySelector('.js-ajax-cart') ||
      document.querySelector('[data-ajax-cart]') ||
      document.querySelector('.drawer--cart') ||
      document.querySelector('.cart-drawer') ||
      document.body; // last resort fallback

    vatObserver.observe(cartRoot, {
      childList: true,
      subtree: true
    });
  });

})();